export type NavigationRendering = {
    dataSource: string;
    language: string;
    fields: {
        [NavigationField.Main]: { value: string };
        [NavigationField.Hamburger]: { value: string };
        [NavigationField.Featured]: { value: string };
        [NavigationField.Unfeatured]: { value: string };
    };
};

export enum NavigationField {
    Main = 'Main Items',
    Hamburger = 'Hamburguer Items',
    Featured = 'Featured Items',
    Unfeatured = 'Unfeatured Items',
}
